/<template>
    <div>
        <div class="d-flex align-items-end">
            <h4>Tipos de documento</h4>
            <div class="flex-grow-1"></div>
            <SettingTypeDocument></SettingTypeDocument>
        </div>
        <hr>
        <SettingListTypeDocument></SettingListTypeDocument>
    </div>
</template>
<script>

import SettingListTypeDocument from './DocumentSetting/Setting-list-type-document.vue'
import SettingTypeDocument from './DocumentSetting/Setting-type-document.vue'
export default {
    name: 'DocumentSetting',

    components: {
        SettingListTypeDocument,
        SettingTypeDocument,
    }
}
</script>

<style scoped>
h4 {
    margin-bottom: 0;
}
</style>